import { Button, Stack, Typography } from "@mui/material";
import { MeetingNotesDrawerContent, useDrawer } from "src/components";
import { MeetingType } from "src/constants";
import { useSession } from "src/hooks";

const MeetingNotesButton = (props: { meetingGuid: string; meetingType: MeetingType }) => {
  const sessionUser = useSession();
  const { showDrawer } = useDrawer();

  function handleMeetingNotesClicked() {
    showDrawer({
      content: (
        <MeetingNotesDrawerContent
          title={
            props.meetingType === MeetingType.Team ? (
              <Typography variant="h6">Meeting Notes</Typography>
            ) : (
              <Stack>
                <Typography variant="h6">My Meeting Notes</Typography>
                <Typography variant="caption">
                  Meeting notes are accessible only to {sessionUser.displayName}.
                </Typography>
              </Stack>
            )
          }
          meetingGuid={props.meetingGuid}
        />
      ),
    });
  }

  return (
    <Button variant="tertiary" onClick={handleMeetingNotesClicked}>
      Meeting Notes
    </Button>
  );
};

export { MeetingNotesButton };
